import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { DocumentoComponent } from './documento/documento.component';
import { CreateDocumentComponent } from './create-document/create-document.component';
import { MainComponent } from './main/main.component';
import { AuthGuard } from './auth.guard';
import { DocumentosComponent } from './documentos/documentos.component';
import { DocumentosCargadosComponent } from './documentos-cargados/documentos-cargados.component';
import { DocumentoCargadoComponent } from './documento-cargado/documento-cargado.component';
import { MainUserComponent } from './main-user/main-user.component';
import { DocumentosInstitucionComponent } from './documentos-institucion/documentos-institucion.component';
import { DocumentoInstitucionComponent } from './documento-institucion/documento-institucion.component';
import { CreateDocumentoCargadoComponent } from './create-documento-cargado/create-documento-cargado.component';
import { UpdateDocumentoCargadoComponent } from './update-documento-cargado/update-documento-cargado.component';
import { EspecialistasDocumentacionComponent } from './especialistas-documentacion/especialistas-documentacion.component';
import { EspecialistaDocumentacionComponent } from './especialista-documentacion/especialista-documentacion.component';
import { CreateEspecialistaDocumentacionComponent } from './create-especialista-documentacion/create-especialista-documentacion.component';
import { InstitucionesComponent } from './instituciones/instituciones.component';
import { InstitucionComponent } from './institucion/institucion.component';
import { CreateInstitucionComponent } from './create-institucion/create-institucion.component';
import { CreateInstitucionesComponent } from './create-instituciones/create-instituciones.component';
import { EvaluacionesComponent } from './evaluaciones/evaluaciones.component';
import { CreateEvaluacionComponent } from './create-evaluacion/create-evaluacion.component';

import { EvaluacionesEstudianteComponent } from './evaluaciones-estudiante/evaluaciones-estudiante.component';
import { EvaluacionEstudianteComponent } from './evaluacion-estudiante/evaluacion-estudiante.component';
import { EstudiantesComponent } from './estudiantes/estudiantes.component';
import { CreateEstudiantesComponent } from './create-estudiantes/create-estudiantes.component';
import { HistorialEvaluacionComponent } from './historial-evaluacion/historial-evaluacion.component';
import { SubidaEvaluacionesComponent } from './subida-evaluaciones/subida-evaluaciones.component';
import { HistorialEvaluacionEstudianteComponent } from './historial-evaluacion-estudiante/historial-evaluacion-estudiante.component';
import { CreateResultadosEvaluacionesComponent } from './create-resultados-evaluaciones/create-resultados-evaluaciones.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'main', component: MainComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomeComponent, pathMatch: 'full' },
  {
    path: 'documento',
    component: DocumentoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-documento',
    component: CreateDocumentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documentos',
    component: DocumentosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documentos-cargados',
    component: DocumentosCargadosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documento-cargado',
    component: DocumentoCargadoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'main-user',
    component: MainUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documentos-institucion',
    component: DocumentosInstitucionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'documento-institucion',
    component: DocumentoInstitucionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-documento-cargado',
    component: CreateDocumentoCargadoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'update-documento-cargado',
    component: UpdateDocumentoCargadoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'especialistas-documentacion',
    component: EspecialistasDocumentacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'especialista-documentacion',
    component: EspecialistaDocumentacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-especialista-documentacion',
    component: CreateEspecialistaDocumentacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'instituciones',
    component: InstitucionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'institucion',
    component: InstitucionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-institucion',
    component: CreateInstitucionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-instituciones',
    component: CreateInstitucionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'evaluaciones',
    component: EvaluacionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-evaluacion',
    component: CreateEvaluacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'evaluaciones-estudiante',
    component: EvaluacionesEstudianteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'evaluacion-estudiante',
    component: EvaluacionEstudianteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'estudiantes',
    component: EstudiantesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-estudiantes',
    component: CreateEstudiantesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'historial-evaluacion',
    component: HistorialEvaluacionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'historial-evaluacion-estudiante',
    component: HistorialEvaluacionEstudianteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'subida-evaluaciones',
    component: SubidaEvaluacionesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create-resultados-evaluaciones',
    component: CreateResultadosEvaluacionesComponent,
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'home' },
];
